import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard } from '@shapeable/ui';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 

    .shp--link-page-banner__titles {
      width: 100%;
    }

    .shp--link-page-banner__content {
      .shp--link-button {
        padding-top: 0;
      }
    }

    .shp--link-page-banner__title {
      font-size: ${32/16}em;
      font-weight: 600;
      letter-spacing: -0.06ch;
      word-spacing: -0.1ch;
      width: 100%;

      margin-top: ${theme.UNIT(6)};
      margin-bottom: ${theme.UNIT(0)};
      font-family: ${theme.FONT('sans')};
    }

    .shp--link-page-banner__subtitle {
      font-weight: 400;
      line-height: 1.05em;
      
      strong, b {
        font-weight: 500;
      }
    }
    
    .shp--link-page-banner__description {
      font-size: 0.80rem;
      line-height: 1.3em;
      margin-top: ${theme.UNIT(3)};
    }

    .shp--grid__item {
      a {
        flex-grow: 1;
      }
    }
  `,
  tablet: css`

    .shp--link-page-banner__title {
      font-size: ${52/15}em;
    }

    .shp--link-page-banner__subtitle {
      font-size: 1.8em;
    }

    .shp--link-page-banner__description {
      font-size: 1rem;
      line-height: 1.3em;
      margin-top: ${theme.UNIT(5)};
    }
  `,
  desktop: css`

    .shp--link-page-banner__title {
      line-height: 1.10em;
      font-size: ${80/15}em;
    }

    .shp--link-page-banner__subtitle {
      font-size: 2.2em;
    }

    .shp--link-page-banner__description {
      font-size: 1.25rem;
    }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <My.Layout 
      entity={entity}
      slices={slices}
      headerProps={{ 
        bannerType: 'carousel',
        overlayColor: '#00000033',
        showOverlayGradient: true, 
        variant: 'overlay', 
        backgroundColor: '#000000',
        fadeColor: '#0000000', 
        showSlideControls: true,
       }}
      className={className}
    />
  )
};
